import { render } from "./SingleList.vue?vue&type=template&id=0a3a6cc1"
import script from "./SingleList.vue?vue&type=script&lang=js"
export * from "./SingleList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__